import { useQuery } from '@tanstack/react-query'
import { fetchTestbedEnvironment, isTestbed } from '@/lib/testbed'

/**
 * The testbed's environment name and the age of its data (the proxy's `/__env`). Only runs in
 * testbed mode (CAP-951); the age is re-rendered from a fixed snapshot time, so the refetch only
 * picks up a changed environment.
 */
export function useTestbedEnvironment() {
  return useQuery({
    queryKey: ['testbed-environment'],
    queryFn: fetchTestbedEnvironment,
    enabled: isTestbed(),
    staleTime: 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    retry: false,
  })
}
